import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cash-payment',
  templateUrl: './cash-payment.component.html',
  styleUrls: ['./cash-payment.component.css']
})
export class CashPaymentComponent implements OnInit {

  model = { 'total': '', 'paid': '', 'remaining': '' };

  constructor(private dialogRef: MatDialogRef<CashPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
    if (this.dialog_data['total'] != undefined)
      this.model.total = this.dialog_data['total'];
  }

  changePaid() {
    this.model['remaining'] = (Number(this.model['paid']) - Number(this.model['total'])).toFixed(2);
  }

  continue() {
    this.dialog_data = { 'op_type': 'success' };  
    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };  
    this.dialogRef.close(this.dialog_data);
  }

}
